import util from "@bmp-vue/core/api/util";

const controller = "Rrc0021";
export default Object.assign({}, util.GetCrud(controller, [""]), {
    ValidarRegistro: function(dto) {
        return util.Axios.Post(
            controller + "/Validar",
            dto
        );
    },
    Incluir: function (dto) {
        return util.Axios.Post(
            controller + "/operacao",
            dto
        );
    },
    IncluirArquivo: function (dto, identEmissorPrincipal, identEmissorAdm) {
        const url = `${process.env.VUE_APP_ROOT_API}${controller}/operacao/importar`;
        const config = {
            headers: {
                'identEmissorPrincipal': identEmissorPrincipal,
                'identEmissorAdm': identEmissorAdm
            }
        };

        return  util.Axios.Dynamic('post', url, dto, config);
    },
    GetRespostaSincronaByCodigo: function (codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/RespostaSincrona`)
    },
    GetRespostaRegistroByCodigo: function (codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/RespostaRegistro`)
    },
    GetOperacaoByCodigo: function (codigo) {
        return util.Axios.GetAll(controller + `/operacao/${codigo}`)
    },
    GetUnidadeRecebivelByCodigo: function (codigo) {
        return util.Axios.GetAll(controller + `/operacao/${codigo}/unidade-recebivel`)
    },
    GetUnidadeRecebivelAConstituirByCodigo: function (codigo) {
        return util.Axios.GetAll(controller + `/operacao/${codigo}/unidade-recebivel-a-constituir`)
    },
    DownloadPaginaUnidadeRecebivel: function (codigoOperacao, codigoPagina) {
        return util.Axios.Get(controller + `/operacao/${codigoOperacao}/unidade-recebivel/${codigoPagina}/download-pagina`)
    },
    DownloadPaginaUnidadeRecebivelAConstituir: function (codigoOperacao, codigoPagina) {
        return util.Axios.Get(controller + `/operacao/${codigoOperacao}/unidade-recebivel-a-constituir/${codigoPagina}/download-pagina`)
    },
    ReprocessarUnidadeRecebivel: function (codigoOperacao, codigoPagina) {
        return util.Axios.Put(controller + `/${codigoOperacao}/unidade-recebivel/${codigoPagina}/reprocessar-pagina`, '', { codigoOperacao: codigoOperacao, codigoPagina: codigoPagina})
    },
    ReprocessarUnidadeRecebivelAConstituir: function (codigoOperacao, codigoPagina) {
        return util.Axios.Put(controller + `/${codigoOperacao}/unidade-recebivel-a-constituir/${codigoPagina}/reprocessar-pagina`, '', { codigoOperacao: codigoOperacao, codigoPagina: codigoPagina})
    },
    ReprocessarConsolidacao: function (codigo) {
        return util.Axios.Put(controller + `/${codigo}/reprocessar-consolidacao`, '', { codigo: codigo})
    }
});
